import { z } from 'zod';
import { AuctionStatus } from '@/types/auction.type.ts';
import { ReportCar, ReportCarSchema } from '@/types/report/car.type.ts';
import { PaginationMeta, PaginationMetaSchema } from '@/types/pagination-meta.ts';

export type ReportAuction = {
    id: number,
    status: AuctionStatus,
    start_date: string,
    end_date: string,
    bids_count: number,
    car: ReportCar,
};

export type ReportAuctionsPaginator = {
    data: ReportAuction[],
    meta: PaginationMeta,
};

export type ReportAuctionsRequestFilter = {
    lot_status?: AuctionStatus[],
    brand_id?: number,
    model_id?: number[],
    vin?: string,
    lot_id?: number,
    auction_from_date?: string,
    auction_to_date?: string,
    limit?: number,
    page?: number,
    sort?: Record<string, string>[],
};

export const ReportAuctionsPaginatorSchema = z.object({
    data: z.object({
        id: z.number(),
        status: z.nativeEnum(AuctionStatus),
        start_date: z.string(),
        end_date: z.string(),
        bids_count: z.number(),
        car: ReportCarSchema,
    }).array(),
    meta: PaginationMetaSchema,
});
